import { Switch } from "@material-ui/core"
import React, { useRef } from "react"
import PopperCustomMenu from "../../../components/Popper/PopperCustomMenu"
import PencilIcon from "../../../components/Icon/Pencil";
import DesativaIcon from "../../../components/Icon/DesativaIcon";
import AtivaIcon from "../../../components/Icon/AtivaIcon";


export const menuOpcoesPopper = (options) => {
  console.log(options)
    const optionsMenuShort = [
      {
        ativo: options.isEdit,
        label: "Editar",
        onClick: (e) => options?.functions?.handleEdit(e),
        icon: <PencilIcon size="24" color="#505050" />,
        id: `cfg-enc-ico-edi-${options.id}`,
      },
      {
        ativo: !options.ativo,
        label: "Ativar",
        onClick: (e) => options?.functions?.handleAtivar(e),
        icon: <AtivaIcon size="24" color="#505050" />,
        id: `cfg-enc-ico-ati-${options.id}`,
      },
      {
        ativo: options.ativo,
        label: "Desativar",
        onClick: (e) => options?.functions?.handleDesativar(e),
        icon: <DesativaIcon size="24" color="#505050" />,
        id: `cfg-enc-ico-des-${options.id}`,
      },
    ];
    return optionsMenuShort;
  }

const PopperMenu = ({ row, functions }) => {
    const ref = useRef(null);
    const handleCloseWithAction = (fn) => {
      return () => {
        ref?.current && ref.current.closePopper()
        fn(row)
      }
    }
  
  
    return (
      <PopperCustomMenu
        id={`cfg-enc-pop-aca-${row.id}`}
        menuOpcoes={menuOpcoesPopper({
          functions: {
            handleEdit: handleCloseWithAction(functions?.handleEditar),
            handleDesativar: handleCloseWithAction(functions?.handleDesativar),
            handleAtivar: handleCloseWithAction(functions?.handleAtivar),
          },
          desativado: !row.ativo,
          isEdit: true,
          ativo: row.ativo,
          id: row.id,
        })}
        colorButton={{background:"#fff"}}
        ref={ref}
      />
    );
};

export const columns = ({ functions }) => [


    {
        Header: "NOME",
        field: "nome",
        getValue: (data) => data.nome
    },
    {
        Header: "DESCRIÇÃO ",
        field: "descricao",
        getValue: (data) => data.descricao
    },
    {
        Header: "STATUS ",
        getValue: (data) => <Switch id={`cfg-enc-swt-sta-${data.id}`} color={"primary"}  checked={data.ativo} aria-disabled={true}/>
    },
    {
        Header: "AÇÕES ",
        getValue: (data) => <PopperMenu row={data} functions={functions} />
    },

]